import { DeprecatedI18NPipesModule } from '@angular/common';
import { Injectable } from '@angular/core';
import { C } from '@angular/core/src/render3';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx-js-style';

@Injectable() 
export class ExportService {

  constructor() { }

  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';

  /*private autofitColumns(json: any[], worksheet: XLSX.WorkSheet) {
    let objectMaxLength: number[] = [];
    json.map(jsonData => {
       Object.entries(jsonData)
             .map(([, v], idx) => {
                let columnValue = v as string
                objectMaxLength[idx] = objectMaxLength[idx] >= columnValue.length ? objectMaxLength[idx] : columnValue.length
             })
    })
    const wscols = objectMaxLength.map((w: number) => ({width: w}))
    worksheet["!cols"] = wscols;

  }*/
  public exportExcel(jsonData: any[], fileName: string): void {

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    ws['!cols'] = [{ width: 20 }, { width: 41 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }]; 
    for (var i in ws) {
      if (typeof ws[i] != 'object') continue;
      let cell = XLSX.utils.decode_cell(i);
      
      ws[i].s = {
        // styling for all cells
        font: {
          name: 'Arial',
          sz: 11
        },
        alignment: {
          //vertical: 'center',
          //horizontal: 'center',
          wrapText: false
        },
      };

      if ((cell.c == 0) && cell.r > 0) {// first column
        //ws[i].cellDates = true;
        ws[i].t = 'd'; 
        ws[i].w = 'MM/DD/YYYY HH:MM';
        ws[i].s.numFmt = 'MM/DD/YYYY HH:MM'; // for dates
        ws[i].z = 'MM/DD/YYYY HH:MM';
        ws[i].v = ws[i].v ;
      }
    }

    const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
wb
    //wb.Sheets['data']['A2'].z = 'MM/DD/YYYY HH:MM';
    //const wb: XLSX.WorkBook = XLSX.utils.book_new();
    //XLSX.utils.book_append_sheet(wb, ws, 'data');
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveExcelFile(excelBuffer, fileName);
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {type: this.fileType});
    FileSaver.saveAs(data, fileName + this.fileExtension);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/export.service.ts